import * as React from 'react';
import Translate from '../../common/functions/translate';
import getInteractionSeverity from '../medicines/MedicineCommon/interactionsSeverityFunctions';
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import Spinner from '../../common/components/spinner/spinner';
import { DrugToDiseaseInteractionsResultModel } from '../../models/interactions/drugToDiseaseInteractionsResultModel';
import { sprintf } from 'sprintf-js';
import InteractionDrugToDseaseDialog from './interactionDrugToDseaseDialog';
import { DrugToDiseaseInteraction } from '../../models/drugToDiseaseInteraction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronDown, faChevronCircleDown } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';

interface IProps {
  lang: string,
  history: any,
  drugToDiseaseInteractionsResult: Array<DrugToDiseaseInteractionsResultModel>;
}

interface IState {
  isLoading: boolean;
  error: any;
  isVisibleInteractionDialog: boolean;
  currentDrugToDiseaseInteraction: DrugToDiseaseInteraction;
  currentMedicineName: string;
}

class InteractionsResultsDrugToDisease extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      isLoading: false,
      isVisibleInteractionDialog: false,
      currentDrugToDiseaseInteraction: new DrugToDiseaseInteraction(),
      currentMedicineName: ''
    };
  }

  componentDidMount() {
  }

  handleInteractionTabClick = (e, drugToDrugInteraction: DrugToDiseaseInteraction, medicineName: string) => {
    e.preventDefault();
    this.setState({
      isVisibleInteractionDialog: true,
      currentDrugToDiseaseInteraction: drugToDrugInteraction,
      currentMedicineName: medicineName
    });
  }

  handleCloseDialogClick = () => {
    this.setState({
      isVisibleInteractionDialog: false
    });
  }

  public render() {
    const { isLoading, error, isVisibleInteractionDialog, currentDrugToDiseaseInteraction, currentMedicineName } = this.state;
    const { drugToDiseaseInteractionsResult } = this.props;

    return (
      <>
        {isLoading ? <Spinner /> : null}
        {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}

        <>
          <ul style={{ width: '100%', listStyleType: "none", paddingLeft: '0' }}>
            {drugToDiseaseInteractionsResult.map(r =>
              <li key={r.medicineId}>
                <div style={{ paddingBottom: '20px' }}>
                  <div style={{ fontWeight: 600, paddingBottom: '5px' }}>
                    {r.brandName} ({r.genericName}):
                  </div>

                  <ul className="list-items">
                    {r.drugToDiseaseInteractions.map((i, index) =>
                      <li key={index + r.medicineId + '-' + i.diseaseId}
                        onClick={(e) => this.handleInteractionTabClick(e, i, r.brandName + (r.genericName))}>
                        <div className="item-info">
                          <div className="item-name">
                            <div className="interaction-severity-icon">{getInteractionSeverity('iconAndText', i.interactionTypeId)}</div>
                            <div>{i.diseaseName}</div>
                          </div>
                        </div>
                        <div className="item-actions">
                          <FontAwesomeIcon icon={faChevronRight} />
                        </div>
                      </li>
                    )
                    }
                  </ul>
                </div>

              </li>
            )}
          </ul>
        </>

        {isVisibleInteractionDialog ? (
          <InteractionDrugToDseaseDialog
            isVisible={isVisibleInteractionDialog}
            closeClick={this.handleCloseDialogClick}
            drugToDiseaseInteraction={currentDrugToDiseaseInteraction}
            medicineName={currentMedicineName}
            lang={this.props.lang}
          />) : null
        }
      </>
    )
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang
  };
}

export default connect(mapsStateToProps)(InteractionsResultsDrugToDisease);
